/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { LicenseOption } from './LicenseOption';
import {
    LicenseOptionFromJSON,
    LicenseOptionFromJSONTyped,
    LicenseOptionToJSON,
} from './LicenseOption';

/**
 * 
 * @export
 * @interface TenantLicenseOptionDto
 */
export interface TenantLicenseOptionDto {
    /**
     * 
     * @type {LicenseOption}
     * @memberof TenantLicenseOptionDto
     */
    option?: LicenseOption;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseOptionDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseOptionDto
     */
    $type?: TenantLicenseOptionDtoTypeEnum;
}


/**
 * @export
 */
export const TenantLicenseOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLicenseComponentDtoTenantLicenseOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.LicenseComponent.Dto.TenantLicenseOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantLicenseOptionDtoTypeEnum = typeof TenantLicenseOptionDtoTypeEnum[keyof typeof TenantLicenseOptionDtoTypeEnum];



/**
 * Check if a given object implements the TenantLicenseOptionDto interface.
 */
export function instanceOfTenantLicenseOptionDto(value?: unknown): value is TenantLicenseOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantLicenseOptionDtoTypeEnum)[0];
}

export function TenantLicenseOptionDtoFromJSON(json: any): TenantLicenseOptionDto {
    return TenantLicenseOptionDtoFromJSONTyped(json, false);
}

export function TenantLicenseOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantLicenseOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'option': json['option'] == null ? undefined : LicenseOptionFromJSON(json['option']),
        'expirationDate': json['expirationDate'] == null ? undefined : json['expirationDate'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TenantLicenseOptionDtoToJSON(value?: TenantLicenseOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'option': LicenseOptionToJSON(value['option']),
        'expirationDate': value['expirationDate'],
        '$type': value['$type'],
    });
}

